import type { ReactElement } from "react";

import {
    type TabContentComponentProps,
    TabWithCounter,
} from "app/pages/sales-intelligence/common-components/tabbed-page-content";
import type { PageTabBase } from "app/pages/sales-intelligence/common-components/tabbed-page-content/types";
import type { AppsSourceType } from "app/pages/sales-intelligence/store/find-apps/types/appsSourceType";

import { useAndroidAppsData } from "../queries/useGetAppsData";

const FindAppsAndroidTabContainer = ({
    tab,
    isSelected,
}: TabContentComponentProps<PageTabBase<AppsSourceType>>): ReactElement => {
    const { data, isFetching } = useAndroidAppsData();

    return (
        <TabWithCounter
            isLoading={isFetching}
            isSelected={isSelected}
            total={data?.totalCount}
            iconNameActive={tab.iconNameActive}
            iconNameInactive={tab.iconNameInactive}
            title={tab.title}
        />
    );
};

export default FindAppsAndroidTabContainer;
